import debounce from '../utilities/debouncer';
import Player from '@vimeo/player';

export default class {
    constructor({
        elId,
        sliderHandle,
        slideHandle,
        prevHandle,
        nextHandle,
        indexHandle,
        animateClass,
    }) {
    // Elements and class variables
        const el = document.getElementById(elId);
        const slider = el.querySelector(sliderHandle);
        const slides = el.querySelectorAll(slideHandle);
        const prev = el.querySelector(prevHandle);
        const next = el.querySelector(nextHandle);
        const index = el.querySelector(indexHandle);
        const dragThreshold = 100;

        // State variables
        let activeIndex = 0;
        let dragging = false;
        let dragDist = 0;
        let lastX = null;
        let offset = 0;
        let left = true;
        let maxWidth = Array.from(slides)
            .reduce((total, slide) => total + slide.offsetWidth, 0) - slider.offsetWidth;

        // Helper functions
        function enabledButtons() {
            if (prev) {
                if (activeIndex === 0) {
                    prev.setAttribute('disabled', true);
                } else {
                    prev.removeAttribute('disabled');
                }
            }

            if (next) {
                if (activeIndex === slides.length - 1) {
                    next.setAttribute('disabled', true);
                } else {
                    next.removeAttribute('disabled');
                }
            }
        }
        function moveSlides(dist) {
            Array.from(slides).forEach(slide => {
                slide.style.transform = `translateX(${dist}px)`;
            });

            index.innerHTML = activeIndex + 1;

            enabledButtons();
        }

        // Event handler functions
        const handleResize = debounce(() => {
            // Update state variables
            offset = -1 * slides[activeIndex].offsetLeft;
            maxWidth = Array.from(slides)
                .reduce((total, slide) => total + slide.offsetWidth, 0) - slider.offsetWidth;

            moveSlides(offset);
        }, 500);
        function handleSame() {
            offset = -1 * slides[activeIndex].offsetLeft;

            moveSlides(offset);
        }
        function handleVideo(slide) {
            const iframe = slide.querySelector('iframe');
            if (iframe) {
                const player = new Player(iframe);
                if (player) {
                    player.pause();
                }
            }
        }
        function handlePrev() {
            if (activeIndex === 0) return;

            // Pause video in the current slide
            handleVideo(slides[activeIndex]);

            // Update state variables
            activeIndex--;
            offset = -1 * slides[activeIndex].offsetLeft;

            moveSlides(offset);
        }
        function handleNext() {
            if (activeIndex === slides.length - 1) return;

            // Pause video in the current slide
            handleVideo(slides[activeIndex]);

            // Update state variables
            activeIndex++;
            offset = -1 * slides[activeIndex].offsetLeft;

            moveSlides(offset);
        }
        function handlePointerMove(e) {
            e.stopPropagation();

            if (!dragging) return;

            const clientX = e.clientX || e.touches[0].clientX;
            const diff = clientX - lastX;

            if (offset + diff > 0 || maxWidth + offset + diff < 0) return;

            // Update state variables
            lastX = clientX;
            dragDist += diff;
            offset += diff;
            left = diff < 0;

            moveSlides(offset);
        }
        function handlePointerDown(e) {
            // Remove animation class for smoother dragging
            el.classList.remove(animateClass);

            // Update state variables
            dragging = true;
            lastX = e.clientX || e.touches[0].clientX;
            left = lastX - slider.getBoundingClientRect().left > slider.offsetWidth / 2;

            slider.addEventListener('pointermove', handlePointerMove);
        }
        function handlePointerUp() {
            if (!dragging) return;

            el.classList.add(animateClass);

            if (Math.abs(dragDist) < dragThreshold) {
                handleSame();
            } else if (left) {
                handleNext();
            } else {
                handlePrev();
            }

            // Update state variables
            dragging = false;
            dragDist = 0;

            slider.removeEventListener('pointermove', handlePointerMove);
        }

        // Add event listeners
        window.addEventListener('resize', handleResize);
        if (prev) { prev.addEventListener('click', handlePrev); }
        if (next) { next.addEventListener('click', handleNext); }
        slider.addEventListener('pointerdown', handlePointerDown);
        slider.addEventListener('pointerup', handlePointerUp);
        slider.addEventListener('pointerleave', handlePointerUp);
        slider.addEventListener('click', (e) => {
            const slide = e.target.closest(slideHandle);
            if (slide) {
                handleVideo(slide);
            }
        });

        // Initialize
        enabledButtons();
    }
}
